import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import api from '../services/api';
import AppLayout from '../components/AppLayout';
import { routes } from '../lib/routes';
import { labelTipo, labelStatus } from '../lib/protocoloLabels';
import './Protocolos.css';

function statusBadgeClass(status) {
  if (status === 'aprovado') return 'protocolos-badge protocolos-badge--aprovado';
  if (status === 'indeferido') return 'protocolos-badge protocolos-badge--indeferido';
  if (status === 'em_analise' || status === 'em_exigencia') return 'protocolos-badge protocolos-badge--analise';
  return 'protocolos-badge protocolos-badge--default';
}

export default function Protocolos() {
  const navigate = useNavigate();
  const { data: protocolos, isLoading, isError } = useQuery('protocolos', () => api.get('/protocolos').then((r) => r.data));

  const actions = (
    <div className="flex flex-wrap gap-2">
      <Link to={routes.dashboard} className="sispro-btn sispro-btn--secondary sispro-btn--sm">
        Dashboard
      </Link>
      <button type="button" className="sispro-btn sispro-btn--primary sispro-btn--sm" onClick={() => navigate(routes.novoProtocolo)}>
        Novo protocolo
      </button>
    </div>
  );

  if (isLoading) {
    return (
      <AppLayout title="Protocolos" subtitle="Lista completa dos seus processos." actions={actions}>
        <div className="protocolos-page">
          <div className="panel protocolos-panel">
            <div className="protocolos-section-head">
              <h2>Seus protocolos</h2>
            </div>
            <div className="protocolos-empty-inner sispro-empty" role="status">
              Carregando…
            </div>
          </div>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout title="Protocolos" subtitle="Lista completa dos seus processos." actions={actions}>
      <div className="protocolos-page">
        <p className="protocolos-intro">Consulte números, tipo de processo e estado de cada pedido.</p>

        {isError ? (
          <div className="panel sispro-empty">Não foi possível carregar a lista. Atualize a página ou tente mais tarde.</div>
        ) : null}

        {!isError && (!protocolos || protocolos.length === 0) ? (
          <div className="panel protocolos-empty-inner">
            <p>Nenhum protocolo encontrado.</p>
            <button type="button" className="sispro-btn sispro-btn--primary" onClick={() => navigate(routes.novoProtocolo)}>
              Criar protocolo
            </button>
          </div>
        ) : null}

        {!isError && protocolos?.length ? (
          <section className="panel protocolos-panel" aria-labelledby="protocolos-lista-heading">
            <div className="protocolos-section-head">
              <h2 id="protocolos-lista-heading">Seus protocolos</h2>
            </div>
            <div className="protocolos-table-wrap">
              <table className="protocolos-table">
                <thead>
                  <tr>
                    <th scope="col">Número</th>
                    <th scope="col">Tipo</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Data</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {protocolos.map((p) => (
                    <tr key={p.id}>
                      <td data-label="Número">
                        <span className="protocolos-numero">{p.numero || p.id}</span>
                      </td>
                      <td data-label="Tipo">
                        <span className="protocolos-tipo">{labelTipo(p.tipo)}</span>
                      </td>
                      <td data-label="Estado">
                        <span className={statusBadgeClass(p.status)}>{labelStatus(p.status)}</span>
                      </td>
                      <td data-label="Data" className="protocolos-data">
                        {p.data_abertura ? new Date(p.data_abertura).toLocaleDateString('pt-BR') : '—'}
                      </td>
                      <td data-label="">
                        <button
                          type="button"
                          className="sispro-btn sispro-btn--secondary sispro-btn--sm"
                          onClick={() => navigate(routes.protocolo(p.id))}
                        >
                          Detalhes
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        ) : null}
      </div>
    </AppLayout>
  );
}
